
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "error-page",
  components: {},
})
export default class ErrorPage extends Vue {
  public type = this.$route.query.type || "";

  constructor() {
    super();
  }

  get error(): { title: string; desc: string } {
    switch (this.type.toString()) {
      case "401":
      case "403":
        return {
          title: "error403.title",
          desc: "error403.description",
        };
      case "500":
        return {
          title: "error500.title",
          desc: "error500.description",
        };
      default:
        return {
          title: "unexpectedError.title",
          desc: "unexpectedError.description",
        };
    }
  }
}
